import { Link } from "@inertiajs/react"
import { AtSign, CalendarPlus, Clock, KeyRound, LogOut, Mail, Monitor, ShieldCheck, User } from "lucide-react"

import GoogleIcon from "@assets/images/icons/google.svg"

import { Button } from "@/components/ui/button"

function formatDate(dateString) {
  if (!dateString) return "—"
  return new Intl.DateTimeFormat("en-US", { month: "long", day: "numeric", year: "numeric" }).format(new Date(dateString))
}

export function SecurityInfo({ user }) {
  const isGoogleUser = user?.provider === "google_oauth2"

  return (
    <div className="max-w-md space-y-8">

      <div>
        <h3 className="flex items-center gap-1.5 text-base font-medium mb-0.5">
          <User className="size-4 text-muted-foreground" aria-hidden />
          Account
        </h3>
        <p className="text-sm text-muted-foreground mb-3">When your account was created and last updated</p>
        <div className="rounded-lg border divide-y">
          <div className="flex items-center justify-between px-4 py-3">
            <div className="flex items-center gap-1.5 text-muted-foreground">
              <CalendarPlus className="size-4 shrink-0" aria-hidden />
              <span className="text-sm">Created</span>
            </div>
            <span className="text-sm">{formatDate(user?.created_at)}</span>
          </div>
          <div className="flex items-center justify-between px-4 py-3">
            <div className="flex items-center gap-1.5 text-muted-foreground">
              <Clock className="size-4 shrink-0" aria-hidden />
              <span className="text-sm">Last updated</span>
            </div>
            <span className="text-sm">{formatDate(user?.updated_at)}</span>
          </div>
        </div>
      </div>

      <div>
        <h3 className="flex items-center gap-1.5 text-base font-medium mb-0.5">
          <ShieldCheck className="size-4 text-muted-foreground" aria-hidden />
          Authentication
        </h3>
        <p className="text-sm text-muted-foreground mb-3">How you sign in to your account</p>
        <div className="rounded-lg border divide-y">
          <div className="flex items-center justify-between px-4 py-3">
            <div className="flex items-center gap-1.5 text-muted-foreground">
              <KeyRound className="size-4 shrink-0" aria-hidden />
              <span className="text-sm">Login method</span>
            </div>
            <div className="flex items-center gap-1.5">
              {isGoogleUser
                ? <GoogleIcon className="size-4" aria-hidden />
                : <Mail className="size-4 text-muted-foreground" aria-hidden />
              }
              <span className="text-sm">{isGoogleUser ? "Google" : "Email"}</span>
            </div>
          </div>
          <div className="flex items-center justify-between px-4 py-3">
            <div className="flex items-center gap-1.5 text-muted-foreground">
              <AtSign className="size-4 shrink-0" aria-hidden />
              <span className="text-sm">Email</span>
            </div>
            <span className="text-sm">{user?.email}</span>
          </div>
        </div>
      </div>

      <div>
        <h3 className="flex items-center gap-1.5 text-base font-medium mb-0.5">
          <Monitor className="size-4 text-muted-foreground" aria-hidden />
          Session
        </h3>
        <p className="text-sm text-muted-foreground mb-3">Sign out of your account on this device</p>
        <Button variant="outline" asChild className="group/signout gap-1.5">
          <Link href="/logout" method="delete" as="button">
            <LogOut className="size-4 text-muted-foreground group-hover/signout:text-foreground transition-colors" />
            Sign out
          </Link>
        </Button>
      </div>

    </div>
  )
}
